import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

import type { SkillsTab } from '@databox/types/domains/ai/settings.enums';
import type { SettingsTab } from '@databox/types/domains/settings/settings.enums';

// The route only redirects, but the legacy params still have to be declared: Ember rejects a transition
// carrying query params no controller owns, and `beforeModel` reads `tab` off that transition. The other
// four are swallowed on purpose — connector and skill state now lives inside the popup, not in the url.
export default class SettingsController extends Controller {
	override queryParams = ['tab', 'connector', 'skillsTab', 'skill', 'installedSkill'];

	@tracked tab: SettingsTab | null = null;
	@tracked connector: string | null = null;
	@tracked skillsTab: SkillsTab | null = null;
	@tracked skill: string | null = null;
	@tracked installedSkill: string | null = null;
}
